module.exports = __webpack_public_path__ + "7f987c74cab7921bd524eda7f2f414f3.svg";